import {
  COLOR_PALETTES,
  SET_COMPANY_LOGO,
  SET_COMPANY_ICON,
} from "../constants";
import { ApiCall } from "../../utils/index";

export const changeTheme = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.postFormData(
      `/company/settings/logo_color_palettes`,
      request.payload,
      token
    );
    dispatch({
      type: COLOR_PALETTES,
      payload: JSON.parse(result.data.color_palette),
    });
    dispatch({ type: SET_COMPANY_LOGO, payload: result.data.logo });
    dispatch({ type: SET_COMPANY_ICON, payload: result.data.icon });
  } catch (error) {
    request.onError(error);
  }
};

export const getColorPalette = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(
      `/custom/get-color-palette/${request.color}`,
      token
    );
    request.onSuccess(result.data);
  } catch (error) {
    request.onError(error);
  }
};
